import SelectSignupPath from '../feature/Login/SelectSignupPath'

const SelectSignupPathPage = () => {
  return <SelectSignupPath />
}

export default SelectSignupPathPage
